import React, { useEffect, useState } from 'react';
import { NextSeo } from 'next-seo';

import Header from '../../components/enfusion/Header';
import Footer from '../../components/enfusion/Footer';
import EventReplays from './event-replays';
import { useAppContext } from '../../util/context';

import { flatListToHierarchical } from '../../util/wordpress';

import Posts from './posts';
import Sidebar from './sidebar';
import NewsHeader from './header';
import NextNavLink from '../../components/util/NextNavLink';

const EventsLayout = ({ pageProps = {} }) => {
    const { events, nextSeoProps, defaults, options } = pageProps;

    const context = useAppContext();
    context.toggleDarkMode(false);
    context.toggleHeaderTheme('bg-white');

    // Filter post function based on category selection
    const [filterCategories, setFilterCategories] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const resetFilterCategories = () => setFilterCategories([]);

    function filterPosts(slug) {
        const index = filterCategories.indexOf(slug);

        if (index === -1) {
            setFilterCategories([...filterCategories, slug]);
        } else {
            const copy = [...filterCategories];
            copy.splice(index, 1);

            setFilterCategories(copy);
        }
    }
    let upcomingEvents = options?.upcomingEventsCta;

    return (
        <>
            <NextSeo {...nextSeoProps} />
            <Header {...pageProps} />

            <main className="text-purple-midnight">
                <NewsHeader title="Join us for our next event" />
                <div className="container pb-24">
                    <div className="relative justify-between lg:flex">
                        <div className="w-full lg:max-w-[224px]">
                            <Sidebar
                                filterPosts={filterPosts}
                                categories={events?.eventTypes?.nodes}
                                months={events?.eventMonths?.nodes}
                                topics={events?.eventTopics?.nodes}
                                regions={events?.eventRegions?.nodes}
                                segments={events?.eventSegments?.nodes}
                                setSearchQuery={setSearchQuery}
                                resetFilterCategories={resetFilterCategories}
                                filterCategories={filterCategories}
                            />
                        </div>
                        <div className="w-full lg:max-w-[830px] pl-0 xl:pl-0 lg:pl-6">
                            <Posts
                                filterCategories={filterCategories}
                                events={events?.contentNodes?.nodes}
                                searchQuery={searchQuery}
                                setSearchQuery={setSearchQuery}
                            />
                        </div>
                    </div>
                    {events?.contentNodes?.nodes && (
                        <EventReplays
                            defaults={defaults}
                            events={events?.contentNodes?.nodes}
                        />
                    )}
                </div>
                <div className={`overflow-hidden  relative  wow fadeInUp`}>
                    <div
                        className={`bg-cover py-4`}
                        style={{
                            backgroundImage: `url(${upcomingEvents?.background?.mediaItemUrl})`
                        }}
                    >
                        <div
                            className={`lg:flex items-center justify-between  bg-cover md:py-28 py-10 lg:text-left text-center  container`}
                        >
                            {upcomingEvents?.heading && (
                                <h3
                                    className={`lg:mb-0 mb-8 wow fadeInUp md:h3 h4 text-purple-midnight `}
                                    dangerouslySetInnerHTML={{
                                        __html: upcomingEvents?.heading
                                    }}
                                />
                            )}
                            {upcomingEvents?.cta && (
                                <NextNavLink
                                    href={upcomingEvents?.cta.url}
                                    target={upcomingEvents?.cta.target}
                                >
                                    <a
                                        className={` btn--midnight btn md:btn--lg wow fadeInUp`}
                                    >
                                        {upcomingEvents?.cta.title}
                                    </a>
                                </NextNavLink>
                            )}
                        </div>
                    </div>
                </div>
            </main>

            <Footer {...pageProps} />
        </>
    );
};

export default EventsLayout;
